import {createContext} from "react";

const barcodePrintOutContext = createContext();

export default barcodePrintOutContext;